import { type SVGProps } from "react"

export function Connector4(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={199}
            height={209}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M19 203a2 2 0 0 0 2 2h5.867a2 2 0 1 0 0-4H21a2 2 0 0 0-2 2m13.689 0a2 2 0 0 0 2 2h11.733a2 2 0 1 0 0-4H34.69a2 2 0 0 0-2 2m19.555 0a2 2 0 0 0 2 2h11.734a2 2 0 1 0 0-4H54.244a2 2 0 0 0-2 2m19.556 0a2 2 0 0 0 2 2h11.733a2 2 0 1 0 0-4H73.8a2 2 0 0 0-2 2m19.556 0a2 2 0 0 0 2 2h11.733a2 2 0 0 0 0-4H93.356a2 2 0 0 0-2 2m19.555 0a2 2 0 0 0 2 2h11.733a2 2 0 1 0 0-4h-11.733a2 2 0 0 0-2 2m19.556 0a2 2 0 0 0 2 2H144.2a2 2 0 1 0 0-4h-11.733a2 2 0 0 0-2 2m19.555 0a2 2 0 0 0 2 2h11.734a2 2 0 0 0 0-4h-11.734a2 2 0 0 0-2 2m19.556 0a2 2 0 0 0 2 2h11.733a2 2 0 1 0 0-4h-11.733a2 2 0 0 0-2 2m19.555 0a2 2 0 0 0 2 2H199v-8.03a2 2 0 1 0-4 0V201h-3.867a2 2 0 0 0-2 2M197 190.93a2 2 0 0 0 2-2v-12.06a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2v-12.06a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2v-12.06a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2v-12.06a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V96.47a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V76.37a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V56.27a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V36.17a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V16.07a2 2 0 1 0-4 0v12.06a2 2 0 0 0 2 2m0-20.1a2 2 0 0 0 2-2V0h-7.496a2 2 0 1 0 0 4H195v4.03a2 2 0 0 0 2 2M103.394 2a2 2 0 0 0 2 2h5.497a2 2 0 0 0 0-4h-5.497a2 2 0 0 0-2 2m12.825 0a2 2 0 0 0 2 2h10.993a2 2 0 0 0 0-4h-10.993a2 2 0 0 0-2 2m18.321 0a2 2 0 0 0 2 2h10.993a2 2 0 0 0 0-4H136.54a2 2 0 0 0-2 2m18.321 0a2 2 0 0 0 2 2h10.993a2 2 0 1 0 0-4h-10.993a2 2 0 0 0-2 2m18.322 0a2 2 0 0 0 2 2h10.992a2 2 0 1 0 0-4h-10.992a2 2 0 0 0-2 2"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={203}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}
